module.exports = __webpack_public_path__ + "img/approvaling.f9907fd2.svg";